import { Component, input } from '@angular/core';
import { PropertyModel } from '../../../../core/models/data/property.model';
import { AddressPipe } from '../../../../core/pipes/address/address.pipe';
import { SafeHtmlPipe } from '../../../../core/pipes/safe-html/safe-html.pipe';
import { CommonChecks } from '../../../../core/utilities/common-checks.utilities';
import { AddressPipeSecondaryAddressFormat } from '../../../../core/enums/base.enums';

@Component({
  selector: 'ms-property-data',
  imports: [AddressPipe, SafeHtmlPipe],
  templateUrl: './property-profile-data.component.html'
})
export class PropertyDataComponent {
  public property = input<PropertyModel | undefined>(undefined);
  public isLoading = input<boolean>(false);
  
  public CommonChecks = CommonChecks;
  public AddressPipeSecondaryAddressFormat = AddressPipeSecondaryAddressFormat;
}
